import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { 
  Button, 
  Modal,
  Space,
  Input,
  Spin 
} from 'antd';

import {  
  TagsOutlined
} from '@ant-design/icons';

import { logo } from '../utilities';
import RequisitionPDF from './RequisitionPDF'

import { authService } from '../../services/authService';
import { API_BASE_URL } from '../../config/api';
import { generateRequisitionPDF } from "./generateRequisitionPDF";

class RequisitionSubmitModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      labelQnt: 3,
      printing: false,
      iframeLoading: true,
      requisitionData: {}
    }
  }

  componentDidMount = () => {
    this.loadData()
  }

  loadData = async() => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/requisitions/${this.props.id}/receipt`,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      console.log(res)
      const doc = generateRequisitionPDF(res.data.requisition, logo);
      const blobURL = doc.output("bloburl");
      window.open(blobURL, "_blank");
      this.setState({
        requisitionData: res.data.requisition,
        iframeLoading: false,
      })
    }).catch(err =>{
      console.log(err);
    })
  }

  handleChange = (nameOrEvent, maybeValue) => {
    const { name, value } = nameOrEvent.target;
    this.setState({ [name]: value });
  };

  printDymo = async () => {
    try {
      const token = await authService.ensureValidToken();
      if (!token) {
        console.error('Not authenticated');
        return;
      }

      const res = await axios({
        method: 'POST',
        url: `${API_BASE_URL}/connect/requisitions/xml`,
        headers: { Authorization: `Bearer ${token}` },
        data: {
          requisitionID: this.props.id,
        }
      });

      // Check Dymo framework
      const fw = window.dymo?.label?.framework;
      if (!fw) {
        console.error("No DYMO framework");
        return;
      }
      
      if (!fw.checkEnvironment()) {
        console.error("DYMO not ready");
        return;
      }

      // Get printers
      const printers = await fw.getLabelWriterPrintersAsync();
      const printerName = printers.find(p => (p.name || "").toLowerCase().includes("550"))?.name || printers?.[0]?.name;

      if (!printerName) {
        console.error("No printer found");
        return;
      }

      const label = fw.openLabelXml(res.data);
      const copies = this.state.labelQnt || 3;
      
      this.setState({ printing: true });
      
      for (let i = 0; i < copies; i++) {
        await label.printAsync(printerName);
      }
      
      this.setState({ printing: false });
      
    } catch(err) {
      console.error('Print error:', err);
      this.setState({ printing: false });
    }
  }

  requestLabels = async () => {
    // window.open on the bare URL sends no Bearer token → 401. Fetch the labels
    // PDF with the auth header and open it as a blob instead.
    const win = window.open('', '_blank');
    try {
      const token = await authService.ensureValidToken();
      if (!token) {
        console.error('Not authenticated');
        if (win) win.close();
        return;
      }
      const res = await axios({
        method: 'GET',
        url: `${API_BASE_URL}/connect/requisitions/${this.props.id}/labels?labelQnt=${this.state.labelQnt}`,
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      if (win) win.location = blobUrl;
      else window.open(blobUrl, '_blank');
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (err) {
      if (win) win.close();
      console.log(err);
    }
  }

  onLoad = () => {
    this.setState({iframeLoading: false})    
  }

  render(){
    return(
      <Modal
        open={this.props.showSubmitModal}
        title=" "
        width={1200}
        onCancel={() => this.props.onClose()}
        footer={[
          this.props.printers.length ? 
          <div style={{ display: 'flex', gap: '8px' }}>
            <div style={{width: '50%'}}>
              <Space.Compact style={{ width: '100%' }}>
                <Input type="number" name="labelQnt" value={this.state.labelQnt} onChange={this.handleChange} />
                <Button type="primary" onClick={this.printDymo}><TagsOutlined /> Print Labels</Button>
              </Space.Compact> 
            </div>
            <Button type="default" style={{ marginLeft: 'auto' }} onClick={() => this.props.onClose()}>Close</Button>
          </div>          
        :
          <div style={{ display: 'flex', gap: '8px' }}>
            <div style={{width: '50%'}}>
              <Space.Compact style={{ width: '100%' }}>
                <Input type="number" name="labelQnt" value={this.state.labelQnt} onChange={this.handleChange} />
                <Button type="primary" onClick={this.requestLabels}><TagsOutlined /> Print Labels</Button>
              </Space.Compact> 
            </div>
            <Button type="default" style={{ marginLeft: 'auto' }} onClick={() => this.props.onClose()}>Close</Button>
          </div>          
        ,
        ]}
      >
        <div style={{display: this.state.iframeLoading ? "none":"initial"}}>
          <RequisitionPDF
            requisition={this.state.requisitionData}   // your JSON from the API
            logoBase64={logo}  // your existing base64 logo
          />
        </div>
        {this.state.iframeLoading &&
          <Fragment>
            <h2>Please wait...</h2>
            {!this.state.iframeLoaded &&
              <div style={{height: window.innerHeight * .7}}>
                <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)'}}><Spin/></div>
              </div>
            }
          </Fragment>          
        }
        
      </Modal>
    )
  }
}
export default RequisitionSubmitModal